(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/responsive-image/assets/javascripts/responsive-image.js') >= 0) return;  svs.modules.push('/components/content/responsive-image/assets/javascripts/responsive-image.js');

var svs = svs || {};

(function(svs, $, window) {
  'use strict';

  svs.content = svs.content || {};

  var detect; var log; var rootEl;

  if (svs.core) {
    detect = svs.core.detect;
    log = svs.core.log ?
      svs.core.log.getLogger('content:responsive-image') :
      console;
  } else {
    log = console;
  }

  function bestFit(options) {
    var bestWidth;
    var elWidth = options.elWidth;
    var el = options.el || document.body;
    var min = options.min || 480;
    var max = options.max || 1600;
    var step = options.step || 160;

    if (!elWidth) {
      elWidth = el.clientWidth || $(window).width();
    }

    if (window.devicePixelRatio) {
      elWidth *= window.devicePixelRatio;
    } else if (detect.screen.retina()) {
      elWidth *= 2;
    }
    bestWidth = elWidth - elWidth % step + step;
    bestWidth = bestWidth > max ? max : bestWidth < min ? min : bestWidth;

    return bestWidth;
  }

  function listen(rootEl) {
    var mutSrv = window.MutationObserver || window.WebKitMutationObserver;
    var evtSupp = window.addEventListener;
    var domChangeTimeoutIndex = null;
    var domChangeTimeout = 100;

    if (mutSrv) {
      var obs = new mutSrv(function(mutations) {
        var i = mutations.length;
        while (i) {
          i--;
          if (mutations[i].addedNodes) {
            i = 0;
            window.clearTimeout(domChangeTimeoutIndex);
            domChangeTimeoutIndex = window.setTimeout(function() {
              loadBackgroundImage();
            }, domChangeTimeout);
          }
        }
      });
      obs.observe(rootEl, {
        childList: true,
        subtree: true,
        attributes: false
      });
    } else if (evtSupp) {
      document.body.addEventListener(
        'DOMNodeInserted',
        function() {
          window.clearTimeout(domChangeTimeoutIndex);
          domChangeTimeoutIndex = window.setTimeout(function() {
            loadBackgroundImage();
          }, domChangeTimeout);
        },
        false
      );
    }
  }

  function loadBackgroundImage() {
    $('img.js-responsive-image').each(function() {
      var imgSrc = $(this).attr('src');
      if (imgSrc && imgSrc.length) {
        var parent = $(this).parents('.responsive-image-wrapper');
        if (parent) {
          parent.addClass('responsive-image-wrapper-bg-fit');
          $(parent).css('background-image', 'url("' + imgSrc + '")');
        }
      }
    });
  }

  if (!Modernizr.objectfit) {
    rootEl = $('body');
    if (rootEl && rootEl[0]) {
      listen(rootEl[0]);
    } else {
      log.debug('Responsive image support disabled');
    }

    $('.responsive-image-wrapper').each(function() {
      $(this).addClass('responsive-image-wrapper-bg-fit');
    });
    loadBackgroundImage();
  }

  svs.content.responsiveImage = {
    bestFit: bestFit
  };
})(svs, $, window);


 })(window);